import React, { Component } from 'react';
import Helmet from 'components/common/Helmet';
import scrollToElement from 'services/scroll';
import PropTypes from 'prop-types';
import { browserHistory } from 'src/history';
import Button from 'components/common/Button';
import TwitterCard from 'components/common/TwitterCard';
import Testimonial from './components/Testimonial';
import Partners from './components/Partners';
import Approach from './components/Approach';
import heroImageEn from './assets/home-hero.webp';
import heroImageFr from './assets/home-hero-fr.webp';
import demoImageEn from './assets/home-demo.png';
import demoImageFr from './assets/home-demo-fr.png';
import productImageEn from './assets/home-product.png';
import productImageFr from './assets/home-product-fr.png';
import TwitterProfile1 from './assets/profile-1.png';
import TwitterImage1 from './assets/twitter-1.png';
import TwitterProfile2 from './assets/profile-2.png';
import TwitterImage2 from './assets/twitter-2.png';
import TwitterProfile3 from './assets/profile-3.png';
import TwitterImage3 from './assets/twitter-3.png';
import HomeModal from './components/HomeModal';
import { openSpaces } from 'services/helpers';

import './styles/home.scss';

export default class Home extends Component {

  constructor(props) {
    super(props);

    this.closeDemoModal = this.closeDemoModal.bind(this);

    this.state = { isDemoModalOpen: false };
  }

  UNSAFE_componentWillMount() {
    const schoolBoardId = this.props.params.schoolBoardId;
    if (schoolBoardId && this.resourcesLoaded()) {
      if (this.isDistrictMigrated(schoolBoardId)) {
        this.redirectToMyBlueprintPlus(schoolBoardId);
      } else {
        this.redirectToMyBlueprint(schoolBoardId);
      }
    }
  }

  resourcesLoaded() {
    const { home, migratedSlpKeys } = this.props.resource;
    return home && migratedSlpKeys;
  }

  isDistrictMigrated(schoolBoardId) {
    const { migratedSlpKeys } = this.props.resource;

    if (!migratedSlpKeys) {
      return null;
    }

    const key = schoolBoardId.toLowerCase();
    return migratedSlpKeys.some(migratedKey => migratedKey.toLowerCase() === key);
  }

  redirectToMyBlueprint(schoolBoardId) {
    window.location = `https://app.myblueprint.ca/?sdid=${schoolBoardId}`;
  }

  redirectToMyBlueprintPlus(schoolBoardId) {
    window.location = `https://account.ca.myblueprint.org/auth/saml?idp=${schoolBoardId}`;
  }

  gotoPath(path) {
    browserHistory.push(path);
  }

  openDemoModal() {
    this.setState({ isDemoModalOpen: true });
  }

  closeDemoModal() {
    this.setState({ isDemoModalOpen: false });
  }

  openTwitter() {
    window.open('https://twitter.com/myBlueprint', '_blank');
  }

  scrollToApproach() {
    scrollToElement('#approach');
  }

  render() {
    if (!this.props.resource.home || !this.props.resource.common) {
      return null;
    }
    const shownTestimonials = this.props.testimonials.filter((testimonial) => {
      return testimonial.fields.showOnHomePage;
    });

    const modalTestimonial = this.props.testimonials.filter((testimonial) => {
      return testimonial.fields.showOnHomeModal;
    });

    const home = this.props.resource.home;
    const common = this.props.resource.common;

    const locale = this.props.locale;
    const isFrench = locale && locale.indexOf('fr') >= 0;
    const heroImage = isFrench ? heroImageFr : heroImageEn;
    const DemoImage = isFrench ? demoImageFr : demoImageEn;
    const ProductImage = isFrench ? productImageFr : productImageEn;

    return (
      <div className="home">
        <Helmet>
          <title>{home.metaTitle}</title>
          <meta id="og-title" property="og:title" content={home.metaTitle} />
          <meta id="meta-description" name="description" content={home.metaDescription} />
          <meta id="og-description" property="og:description" content={home.metaDescription} />
          <meta id="og-url" property="og:url" content="https://myblueprint.ca" />
        </Helmet>
        <div className="banner-bg stripe-hero-gradient stripe-hero-gradient--bottom-clip">
          <div className="container home-hero">
            <div className="home-hero__content">
              <h1 className="home-hero__content__title">{home.title}</h1>
              <div className="medium-font home-hero__content__subtitle">
                {home.subtitle}
              </div>
              <div>
                <Button className="button--action" onClick={() => this.scrollToApproach()}>
                  {common.learnMore}
                </Button>
              </div>
            </div>
            <div className="home-hero__image">
              <img src={heroImage} alt="myBlueprint" fetchPriority="high" />
            </div>
          </div>
        </div>
        <div className="home-res-image">
          <img src={heroImage} alt="myBlueprint" fetchPriority="high" />
        </div>

        <div id="approach" className="stripe">
          <div className="container-narrow column-center">
            <h2 className="column-center__title">{home.approachTitle}</h2>
            <div className="column-center__subtitle column-center__subtitle--medium-grey">
              {home.approachSubTitle}
            </div>
            <Approach approaches={home.approaches} />
          </div>
        </div>

        <div className="stripe stripe--no-padding-top-on-mobile">
          <div className="container-narrow">
            <div className="home-products">
              <div className="home-products__content">
                <h2 className="center-on-mobile">{home.productsTitle}</h2>
                <div className="center-on-mobile subtitle-medium-grey">
                  {home.productsSubTitle}
                </div>
                <div className="home-products__content__product-group">
                  <div className="home-products__content__product-group__product">
                    <h3 className="home-products__content__product-group__product__title">{common.spaces}</h3>
                    <div className="subtitle3-primary">
                      {common.gradesK12}
                    </div>
                    <div className="line-short" />
                    <div className="home-products__content__product-group__product__description
                     small-font-grey">
                      {home.spacesDescription}
                    </div>
                    <div className="home-products__content__product-group__product__button">
                      <Button onClick={() => openSpaces(locale)}>
                        {common.learnMore}
                      </Button>
                    </div>
                  </div>
                  <div className="home-products__content__product-group__product">
                    <h3 className="home-products__content__product-group__product__title">{common.educationPlanner}</h3>
                    <div className="subtitle3-primary">
                      {common.grade712P}
                    </div>
                    <div className="line-short" />
                    <div className="home-products__content__product-group__product__description
                      small-font-grey">
                      {home.epDescription}
                    </div>
                    <div className="home-products__content__product-group__product__button">
                      <Button onClick={() => this.gotoPath('/products/educationplanner')}>
                        {common.learnMore}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="home-products__image-container">
                <img className="home-products__image-container__image"
                  src={ProductImage} alt="Product" />
              </div>
            </div>
          </div>
        </div>

        <div className="stripe-thick-gradient stripe-thick-gradient--top-clip">
          <div className="column-center stripe stripe stripe--no-padding-top-on-mobile">
            <div className="home-testimonials">
              <Testimonial testimonials={shownTestimonials} />
            </div>
          </div>

          <div className="column-center stripe stripe--no-padding-top-on-mobile">
            <h2 className="white column-center__title">
              <span className="white">{home.partnersTitle}</span>
            </h2>
            <div className="subtitle-grey column-center__subtitle">
              {home.partnersSubTitle}
            </div>
            <Partners province={this.props.geo ? this.props.geo.state_prov : null} resource={this.props.resource} />
          </div>

          <div className="stripe stripe--no-padding-top-on-mobile">
            <div className="container-medium">
              <div className="column-center">
                <h2 className="column-center__title">
                  <span className="white">{home.twitterTitle}</span>
                </h2>
                <div className="subtitle-grey column-center__subtitle column-center__subtitle--wide">
                  {home.twitterSubTitle}
                </div>
              </div>
              { home.tweets &&
                <div className="home-twitter">
                  <TwitterCard name={home.tweets[0].name} handle={home.tweets[0].handle}
                    profilePic={TwitterProfile1}
                    imgSrc={TwitterImage1}>
                    {home.tweets[0].text}
                  </TwitterCard>
                  <TwitterCard name={home.tweets[1].name} handle={home.tweets[1].handle}
                    profilePic={TwitterProfile2}
                    imgSrc={TwitterImage2}>
                    {home.tweets[1].text}
                  </TwitterCard>
                  <TwitterCard name={home.tweets[2].name} handle={home.tweets[2].handle}
                    profilePic={TwitterProfile3}
                    imgSrc={TwitterImage3}>
                    {home.tweets[2].text}
                  </TwitterCard>
                </div>
              }
              <div className="column-center__button">
                <Button onClick={this.openTwitter}>
                  {home.twitterJoin}
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="home-footer-bg">
          <div className="container-narrow">
            <div className="home-demo">
              <div className="home-demo__content">
                <div className="home-demo__content__title">{home.requestTitle}</div>
                <div className="home-demo__content__divider" />
                <div className="home-demo__content__subtitle">
                  {home.requestSubTitle}
                </div>
                <div className="home-demo__content__button">
                  <Button className="button--action" onClick={() => this.openDemoModal()}>{home.requestDemo}</Button>
                </div>
              </div>
              <div className="home-demo__image-container">
                <img className="home-demo__image-container__image" src={DemoImage} />
              </div>
            </div>
          </div>
        </div>
        <div className={'home-demo-modal-overlay ' + (this.state.isDemoModalOpen ? 'home-demo-modal-overlay__open' : '')} onClick={() => this.closeDemoModal()} />
        <div className={'home-demo-modal ' + (this.state.isDemoModalOpen ? 'home-demo-modal__open' : '')}>
          <HomeModal home={home} testimonialInfo={modalTestimonial} closeModal={this.closeDemoModal} />
        </div>
      </div>
    );
  }
}

Home.propTypes = {
  resource: PropTypes.object,
  testimonials: PropTypes.array,
  params: PropTypes.object,
  geo: PropTypes.object,
  locale: PropTypes.string
};

